
import { Check, Minus } from "lucide-react";

interface FeatureRow {
  feature: string;
  basic: boolean | string;
  pro: boolean | string;
  enterprise: boolean | string;
  isGroupHeader?: boolean;
}

const featureRows: FeatureRow[] = [
  // Drawing Tools
  { feature: "Drawing Tools", isGroupHeader: true, basic: "", pro: "", enterprise: "" },
  { feature: "Skin Marker & Scalpel Tools", basic: true, pro: true, enterprise: true },
  { feature: "Angles & Measurements", basic: true, pro: true, enterprise: true },
  { feature: "Zoom Controls", basic: true, pro: true, enterprise: true },
  
  // Editing Tools
  { feature: "Editing Tools", isGroupHeader: true, basic: "", pro: "", enterprise: "" },
  { feature: "Basic Editing (Eraser, Undo, Delete)", basic: true, pro: true, enterprise: true },
  { feature: "Layer Management", basic: true, pro: true, enterprise: true },

  // Image Features
  { feature: "Image Features", isGroupHeader: true, basic: "", pro: "", enterprise: "" },
  { feature: "Surgical Scenarios", basic: "Limited", pro: "Unlimited", enterprise: "Unlimited" },
  { feature: "Templates", basic: "Limited", pro: "Unlimited", enterprise: "Unlimited" },
  { feature: "Mobile Upload", basic: false, pro: true, enterprise: true },

  // AI Features
  { feature: "AI Features", isGroupHeader: true, basic: "", pro: "", enterprise: "" },
  { feature: "AI Generated Images", basic: "Limited", pro: true, enterprise: true },
  { feature: "AI Analysis", basic: "25/month", pro: "Unlimited", enterprise: "Unlimited" },

  // Storage & Export
  { feature: "Storage & Export", isGroupHeader: true, basic: "", pro: "", enterprise: "" },
  { feature: "Storage", basic: "Limited", pro: "Unlimited", enterprise: "Unlimited" },
  { feature: "Export Drawings", basic: false, pro: true, enterprise: true },
  { feature: "Export Analysis", basic: false, pro: true, enterprise: true }
];

export function FeatureComparisonTable() {
  return (
    <div id="features-comparison" className="bg-white rounded-3xl p-8 border border-gray-200 shadow-sm max-w-5xl mx-auto">
      {/* Table Headers */}
      <div className="grid grid-cols-4 gap-4 mb-8 border-b border-gray-200 pb-6">
        <div className="text-lg font-bold text-gray-900">Features</div>
        <div className="text-lg font-bold text-gray-900 text-center">Studio Only</div>
        <div className="text-lg font-bold text-gray-900 text-center">thePlasticsPro</div>
        <div className="text-lg font-bold text-gray-900 text-center">Enterprise</div>
      </div>

      {/* Table Content */}
      <div className="space-y-2">
        {featureRows.map((row, index) => (
          <div 
            key={index}
            className={`grid grid-cols-4 items-center ${
              row.isGroupHeader 
                ? "mt-8 mb-4 first:mt-0" 
                : "py-4 border-b border-gray-50 last:border-b-0 hover:bg-gray-50/50 transition-colors"
            }`}
          >
            <span className={`${
              row.isGroupHeader 
                ? "text-xs font-bold text-[#000000e6] uppercase tracking-widest" 
                : "text-base text-gray-700 leading-relaxed"
            }`}>
              {row.feature}
              {row.feature === "Mobile Upload" && (
                <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700">
                  Coming Soon!
                </span>
              )}
            </span>

            {/* Basic/Studio Column */}
            <div className="text-center">
              {row.isGroupHeader ? null : row.basic === true ? (
                <Check className="h-6 w-6 text-green-600 mx-auto stroke-[2.5]" />
              ) : row.basic === false ? (
                <Minus className="h-6 w-6 text-gray-300 mx-auto" />
              ) : (
                <span className="text-sm text-gray-600">{row.basic}</span>
              )}
            </div>

            {/* Pro Column */}
            <div className="text-center">
              {row.isGroupHeader ? null : row.pro === true ? (
                <Check className="h-6 w-6 text-blue-600 mx-auto stroke-[2.5]" />
              ) : row.pro === false ? (
                <Minus className="h-6 w-6 text-gray-300 mx-auto" />
              ) : (
                <span className="text-sm text-gray-600">{row.pro}</span>
              )}
            </div>

            {/* Enterprise Column */}
            <div className="text-center">
              {row.isGroupHeader ? null : row.enterprise === true ? (
                <Check className="h-6 w-6 text-purple-600 mx-auto stroke-[2.5]" />
              ) : row.enterprise === false ? (
                <Minus className="h-6 w-6 text-gray-300 mx-auto" />
              ) : (
                <span className="text-sm text-gray-600">{row.enterprise}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
